import type { XY } from "@designboticteam/core";
import { arePointsEqual } from "./arePointsEqual";

/**
 * Normalizes a polygon vertex list to a closed ring.
 */
function toClosedPolygon(points: Array<XY>): Array<XY> | null {
	const last = points[points.length - 1];
	const isClosed = points.length > 1 && arePointsEqual(points[0], last);
	const openPolygon = isClosed ? points.slice(0, -1) : points;

	if (openPolygon.length < 3) {
		return null;
	}

	return [...openPolygon, openPolygon[0]];
}

export { toClosedPolygon };
